import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

function copy(translate: (key: string) => string, key: string, fallback: string): string {
  const value = translate(key);
  return value === key ? fallback : value;
}

export default function AlreadyOwned() {
  const { t, currentLanguage } = useTranslation();
  const [params] = useSearchParams();
  const slug = params.get('slug') || '';
  const [name, setName] = useState('');

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    fetch(`/api/plugins/${encodeURIComponent(slug)}?lang=${currentLanguage}`)
      .then((response) => response.json())
      .then((data) => {
        const pluginName = data?.data?.name;
        if (!cancelled && typeof pluginName === 'string') setName(pluginName);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [slug, currentLanguage]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="container mx-auto px-6 py-16 max-w-lg text-center">
        <h1 className="text-3xl font-bold text-white mb-4">
          {name ? `${name}. ` : ''}
          {copy(t, 'checkout.already_owned', 'You already own this plugin')}
        </h1>
        <p className="text-gray-300 mb-8">
          {copy(
            t,
            'checkout.already_owned_body',
            'The account you signed in with already has this plugin. You do not need to buy it again. To use it, download the installer.',
          )}
        </p>
        <Link
          to="/account/downloads"
          className="inline-block bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-semibold"
        >
          {copy(t, 'checkout.added_installer', 'Download the installer')}
        </Link>
      </div>
    </div>
  );
}
